import React, { Component } from 'react';
import { Router, Switch, Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { intlShape, injectIntl } from 'react-intl';
import { LastLocationProvider } from 'react-router-last-location';

import { createBrowserHistory } from 'history';

import { withStyles } from '@material-ui/styles';
import withRoot from '../styles/withRoot';

import Login from './knowhow/Login';
import ResetPassword from './knowhow/ResetPassword';
import RecoveryPassword from './knowhow/RecoveryPassword';
import Pin from './knowhow/Pin';
import NotFound from './NotFound';
import Logout from './Logout';
import Session from '../components/labels/Session';
import Sse from '../components/labels/Sse';

import Home from '../components/Home';
import Dashboad from '../components/complex/dashboard/Index';
import Checks from '../components/complex/families/Index';
import Instances from '../components/complex/instances/Index';
import Alerts from '../components/complex/alerts/Index';
import Forms from '../components/complex/forms/Index';

import Manage from '../components/complex/manage/Index';
import ManageChecks from '../components/complex/manage/checks/Index';
import ManageCheckForms from '../components/complex/manage/checks/Main';
import Employees from '../components/complex/manage/employees/Index';
import Employee from '../components/complex/manage/employee/Index';
import Users from '../components/complex/manage/users/Index';
import User from '../components/complex/manage/user/Index';
import Catalogs from '../components/complex/manage/catalogs/Index';
import Catalog from '../components/complex/manage/catalog/Index';
import Customers from '../components/complex/manage/customers/Index';
import Customer from '../components/complex/manage/customer/Index';
import Displays from '../components/complex/manage/displays/Index';
import Display from '../components/complex/manage/display/Index';
import Termometres from '../components/complex/manage/termometres/Index';
import Termometre from '../components/complex/manage/termometre/Index';
import Provider from '../components/complex/manage/provider/Index';
import Providers from '../components/complex/manage/providers/Index';
import Reference from '../components/complex/manage/reference/Index';
import References from '../components/complex/manage/references/Index';
import Template from '../components/complex/manage/template/Index';
import Templates from '../components/complex/manage/templates/Index';
import LocalsInfo from '../components/complex/manage/locals/Index';
import LocalInfo from '../components/complex/manage/local/Index';
import Roles from '../components/complex/manage/roles/Index';

import Inventory from '../components/complex/inventory/Index';
import Products from '../components/complex/inventory/products/Index';
import Recipe from '../components/complex/inventory/recipe/Index';
import Locals from '../components/complex/inventory/locals/Index';
import Local from '../components/complex/inventory/local/Index';

import Forecasts from '../components/complex/inventory/forecasts/Index';
import Forecast from '../components/complex/inventory/forecast/Index';

import Machines from '../components/complex/inventory/machines/Index';
import Machine from '../components/complex/inventory/machine/Index';
import Lists from '../components/complex/inventory/catalogs/Index';
import List from '../components/complex/inventory/catalog/Index';
import OuiChef from '../components/complex/inventory/fast/Index';

import DisplaysCallback from '../components/complex/manage/displayscallback/Index';
import Reports from '../components/complex/reports/Index';
import Search from '../components/complex/reports/search/Index';
import Decrease from '../components/complex/reports/decrease/Index';
import Lote from '../components/complex/reports/lot/Index';
import APPCC from '../components/complex/reports/appcc/Index';
import ReportEmployee from '../components/complex/reports/employee/Index';
import STS from '../components/complex/reports/sts/Index';
import Visibilty from '../components/complex/reports/visibility/Index';
import VisibiltyMenu from '../components/complex/reports/visibility/Menu';

import Xhef from '../components/complex/xhef/Index';

import Communications from '../components/complex/communications/Index';

import CleanLocal from '../components/complex/cleanlocal/index';

import Onboarding from '../components/complex/onboarding/index';

import { bindActionCreators } from 'redux';
import * as actionsSession from '../actions/session.actions';
import * as actionsAlert from '../actions/alert.actions';

import rotate from '../images/iflares-icons-420x420-02.svg';

const history = createBrowserHistory();
const styles = (theme) => ({});

function PrivateRoute({ component: Component, user, ...rest }) {
    return (
        <Route
            {...rest}
            render={(props) =>
                user ? (
                    <Component {...props} />
                ) : (
                    <Redirect to={{ pathname: '/user/login', state: { from: props.location } }} />
                )
            }
        />
    );
}

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            orientation: window.orientation,
            isFullscreenEnabled: true,
        };
    }

    componentDidMount() {
        window.onbeforeunload = function(e) {
            //this.logout();
        };
    }

    logout() {
        console.log('logout');
        this.props.logOutUser();
    }

    render() {
        const divStyle = { backgroundImage: 'url(' + rotate + ')' };
        const { user } = this.props;
        const HOMEID = 0;
        const PROCESSID = 1;
        const OUICHEFID = 2;
        const XEFID = 3;
        const REPORTSID = 4;
        const ALERTSID = 5;
        const MANAGEID = 6;
        const COMMUNICATIONS = 7;

        return (
            <div>
                <div id="main" className="main">
                    <Router history={history}>
                        <LastLocationProvider>
                            <Switch>
                                <PrivateRoute
                                    exact
                                    path="/"
                                    user={user}
                                    component={(props) => (
                                        <Home {...props} id={HOMEID} title={'title'}>
                                            <Dashboad />
                                        </Home>
                                    )}
                                />
                                <Route
                                    exact
                                    path="/sts/:id"
                                    component={(props) => <CleanLocal id={props.match.params.id} />}
                                />
                                <Route
                                    exact
                                    path="/onboarding/:id"
                                    component={(props) => <Onboarding id={props.match.params.id} />}
                                />
                                <Route exact path="/logout" component={Logout} />
                                <Route exact path="/user/login" component={Login} />
                                <Route exact path="/password-reset" component={ResetPassword} />

                                <Route
                                    exact
                                    path="/recovery/:token"
                                    component={(props) => (
                                        <RecoveryPassword
                                            {...props}
                                            param={props.match.params.token}
                                        />
                                    )}
                                />
                                <PrivateRoute exact path="/user/pin" user={user} component={Pin} />
                                <PrivateRoute
                                    exact
                                    path="/ouichef/"
                                    user={user}
                                    component={(props) => (
                                        <Home {...props} id={OUICHEFID} title={'fast_title'}>
                                            <OuiChef />
                                        </Home>
                                    )}
                                />
                                <PrivateRoute
                                    exact
                                    path="/ouichef/:id"
                                    user={user}
                                    component={(props) => (
                                        <Home {...props} id={OUICHEFID} title={'fast_title'}>
                                            <Xhef id={props.match.params.id} />
                                        </Home>
                                    )}
                                />
                                <PrivateRoute
                                    exact
                                    path="/processes/"
                                    user={user}
                                    component={(props) => (
                                        <Home {...props} id={PROCESSID} title={'process_title'}>
                                            <Checks />
                                        </Home>
                                    )}
                                />
                                <PrivateRoute
                                    exact
                                    path="/processes/:family"
                                    user={user}
                                    component={(props) => (
                                        <Home
                                            {...props}
                                            id={PROCESSID}
                                            param={props.match.params.family}
                                        >
                                            <Checks
                                                param={props.match.params.family}
                                                params={props.match.params}
                                            />
                                        </Home>
                                    )}
                                />
                                <PrivateRoute
                                    exact
                                    path="/processes/:family/:process"
                                    user={user}
                                    component={(props) => (
                                        <Home
                                            {...props}
                                            id={PROCESSID}
                                            param={props.match.params.process}
                                        >
                                            <Instances
                                                param={props.match.params.process}
                                                params={props.match.params}
                                            />
                                        </Home>
                                    )}
                                />
                                <PrivateRoute
                                    exact
                                    path="/processes/:family/:process/:instance"
                                    user={user}
                                    component={(props) => (
                                        <Forms
                                            param={props.match.params.instance}
                                            params={props.match.params}
                                        />
                                    )}
                                />
                                <PrivateRoute
                                    exact
                                    path="/processes/:family/:process/:instance/:form"
                                    user={user}
                                    component={(props) => (
                                        <Forms
                                            param={props.match.params.form}
                                            params={props.match.params}
                                            showForm
                                        />
                                    )}
                                />
                                <PrivateRoute
                                    exact
                                    path="/xef/"
                                    user={user}
                                    component={(props) => (
                                        <Home {...props} id={XEFID} title={'inventory_title'}>
                                            <Inventory />
                                        </Home>
                                    )}
                                />
                                <PrivateRoute
                                    exact
                                    path="/xef/forecast"
                                    user={user}
                                    component={(props) => (
                                        <Home {...props} id={XEFID} title={'production_list_title'}>
                                            <Forecasts />
                                        </Home>
                                    )}
                                />
                                <PrivateRoute
                                    exact
                                    path="/xef/forecast/:id"
                                    user={user}
                                    component={(props) => (
                                        <Home
                                            {...props}
                                            id={XEFID}
                                            back
                                            title={'production_list_title'}
                                        >
                                            <Forecast id={props.match.params.id} />
                                        </Home>
                                    )}
                                />
                                <PrivateRoute
                                    exact
                                    path="/xef/forecast/:id/:back"
                                    user={user}
                                    component={(props) => (
                                        <Home
                                            {...props}
                                            id={XEFID}
                                            back
                                            title={'production_list_title'}
                                        >
                                            <Forecast
                                                id={props.match.params.id}
                                                back={props.match.params.back}
                                            />
                                        </Home>
                                    )}
                                />
                                <PrivateRoute
                                    exact
                                    path="/xef/products"
                                    user={user}
                                    component={(props) => (
                                        <Home {...props} id={XEFID} title={'products_title'}>
                                            <Products />
                                        </Home>
                                    )}
                                />
                                <PrivateRoute
                                    exact
                                    path="/xef/products/new_product"
                                    user={user}
                                    component={(props) => (
                                        <Home {...props} id={XEFID} back title={'products_title'}>
                                            <Recipe />
                                        </Home>
                                    )}
                                />
                                <PrivateRoute
                                    exact
                                    path="/xef/products/:id"
                                    user={user}
                                    component={(props) => (
                                        <Home {...props} id={XEFID} back title={'products_title'}>
                                            <Recipe id={props.match.params.id} />
                                        </Home>
                                    )}
                                />
                                <PrivateRoute
                                    exact
                                    path="/xef/locals"
                                    user={user}
                                    component={(props) => (
                                        <Home
                                            {...props}
                                            id={XEFID}
                                            back
                                            title={'manage_local_menu'}
                                        >
                                            <Locals />
                                        </Home>
                                    )}
                                />
                                <PrivateRoute
                                    exact
                                    path="/xef/locals/:local"
                                    user={user}
                                    component={(props) => (
                                        <Home
                                            {...props}
                                            id={XEFID}
                                            back
                                            title={'manage_local_menu'}
                                        >
                                            <Local id={props.match.params.local} />
                                        </Home>
                                    )}
                                />
                                <PrivateRoute
                                    exact
                                    path="/xef/catalogs"
                                    user={user}
                                    component={(props) => (
                                        <Home
                                            {...props}
                                            id={XEFID}
                                            back
                                            title={'manage_local_menu'}
                                        >
                                            <Lists />
                                        </Home>
                                    )}
                                />
                                <PrivateRoute
                                    exact
                                    path="/xef/catalogs/:id"
                                    user={user}
                                    component={(props) => (
                                        <Home
                                            {...props}
                                            id={XEFID}
                                            back
                                            title={'manage_local_menu'}
                                        >
                                            <List id={props.match.params.id} />
                                        </Home>
                                    )}
                                />
                                <PrivateRoute
                                    exact
                                    path="/reports/"
                                    user={user}
                                    component={(props) => (
                                        <Home {...props} id={REPORTSID} title={'report_title'}>
                                            <Reports />
                                        </Home>
                                    )}
                                />
                                <PrivateRoute
                                    exact
                                    path="/reports/decrease"
                                    user={user}
                                    component={(props) => (
                                        <Home
                                            {...props}
                                            id={REPORTSID}
                                            back
                                            title={'manage_local_menu'}
                                        >
                                            <Decrease />
                                        </Home>
                                    )}
                                />
                                <PrivateRoute
                                    exact
                                    path="/reports/decrease/result"
                                    user={user}
                                    component={(props) => (
                                        <Home
                                            {...props}
                                            id={REPORTSID}
                                            back
                                            title={'manage_local_menu'}
                                        >
                                            <Decrease result />
                                        </Home>
                                    )}
                                />
                                <PrivateRoute
                                    exact
                                    path="/reports/controlpanel"
                                    user={user}
                                    component={(props) => (
                                        <Home
                                            {...props}
                                            id={REPORTSID}
                                            back
                                            title={'visibility_menu'}
                                        >
                                            <VisibiltyMenu />
                                        </Home>
                                    )}
                                />
                                <PrivateRoute
                                    exact
                                    path="/reports/controlpanel/result"
                                    user={user}
                                    component={(props) => (
                                        <Home
                                            {...props}
                                            id={REPORTSID}
                                            back
                                            title={'visibility_menu'}
                                        >
                                            <Visibilty />
                                        </Home>
                                    )}
                                />
                                <PrivateRoute
                                    exact
                                    path="/reports/sts"
                                    user={user}
                                    component={(props) => (
                                        <Home
                                            {...props}
                                            id={REPORTSID}
                                            back
                                            title={'report_sts_menu'}
                                        >
                                            <STS />
                                        </Home>
                                    )}
                                />
                                <PrivateRoute
                                    exact
                                    path="/reports/sts/result"
                                    user={user}
                                    component={(props) => (
                                        <Home
                                            {...props}
                                            id={REPORTSID}
                                            back
                                            title={'report_sts_menu'}
                                        >
                                            <STS result />
                                        </Home>
                                    )}
                                />
                                <PrivateRoute
                                    exact
                                    path="/reports/APPCC"
                                    user={user}
                                    component={(props) => (
                                        <Home
                                            {...props}
                                            id={REPORTSID}
                                            back
                                            title={'manage_appcc_menu'}
                                        >
                                            <APPCC />
                                        </Home>
                                    )}
                                />
                                <PrivateRoute
                                    exact
                                    path="/reports/APPCC/result"
                                    user={user}
                                    component={(props) => (
                                        <Home
                                            {...props}
                                            id={REPORTSID}
                                            back
                                            title={'manage_appcc_menu'}
                                        >
                                            <APPCC result />
                                        </Home>
                                    )}
                                />
                                <PrivateRoute
                                    exact
                                    path="/reports/employee"
                                    user={user}
                                    component={(props) => (
                                        <Home
                                            {...props}
                                            id={REPORTSID}
                                            back
                                            title={'report_employee_menu'}
                                        >
                                            <ReportEmployee />
                                        </Home>
                                    )}
                                />
                                <PrivateRoute
                                    exact
                                    path="/reports/employee/detail/:id"
                                    user={user}
                                    component={(props) => (
                                        <Home
                                            {...props}
                                            id={REPORTSID}
                                            back
                                            title={'report_employee_menu'}
                                        >
                                            <ReportEmployee
                                                id={'detail'}
                                                proceso={props.match.params.id}
                                            />
                                        </Home>
                                    )}
                                />
                                <PrivateRoute
                                    exact
                                    path="/reports/employee/:id"
                                    user={user}
                                    component={(props) => (
                                        <Home
                                            {...props}
                                            id={REPORTSID}
                                            back
                                            title={'report_employee_menu'}
                                        >
                                            <ReportEmployee id={props.match.params.id} />
                                        </Home>
                                    )}
                                />
                                <PrivateRoute
                                    exact
                                    path="/reports/lot"
                                    user={user}
                                    component={(props) => (
                                        <Home
                                            {...props}
                                            id={REPORTSID}
                                            back
                                            title={'report_search_lot_temp'}
                                        >
                                            <Lote />
                                        </Home>
                                    )}
                                />
                                <PrivateRoute
                                    exact
                                    path="/reports/lot/result"
                                    user={user}
                                    component={(props) => (
                                        <Home
                                            {...props}
                                            id={REPORTSID}
                                            back
                                            title={'report_search_lot_temp'}
                                        >
                                            <Lote result />
                                        </Home>
                                    )}
                                />
                                <PrivateRoute
                                    exact
                                    path="/reports/search"
                                    user={user}
                                    component={(props) => (
                                        <Home
                                            {...props}
                                            id={REPORTSID}
                                            back
                                            title={'report_search_values'}
                                        >
                                            <Search />
                                        </Home>
                                    )}
                                />
                                <PrivateRoute
                                    exact
                                    path="/reports/search/result"
                                    user={user}
                                    component={(props) => (
                                        <Home
                                            {...props}
                                            id={REPORTSID}
                                            back
                                            title={'report_search_values'}
                                        >
                                            <Search result />
                                        </Home>
                                    )}
                                />
                                <PrivateRoute
                                    exact
                                    path="/alerts/"
                                    user={user}
                                    component={(props) => (
                                        <Home
                                            {...props}
                                            id={ALERTSID}
                                            noprominent
                                            title={'warning_title'}
                                        >
                                            <Alerts />
                                        </Home>
                                    )}
                                />
                                <PrivateRoute
                                    exact
                                    path="/manage/"
                                    user={user}
                                    component={(props) => (
                                        <Home {...props} id={MANAGEID} title={'manage_title'}>
                                            <Manage />
                                        </Home>
                                    )}
                                />
                                <PrivateRoute
                                    exact
                                    path="/xef/machines"
                                    user={user}
                                    component={(props) => (
                                        <Home
                                            {...props}
                                            id={XEFID}
                                            back
                                            title={'manage_machines_menu'}
                                        >
                                            <Machines />
                                        </Home>
                                    )}
                                />
                                <PrivateRoute
                                    exact
                                    path="/xef/machines/new_machine"
                                    user={user}
                                    component={(props) => (
                                        <Home
                                            {...props}
                                            id={XEFID}
                                            back
                                            title={'manage_machines_menu'}
                                        >
                                            <Machine />
                                        </Home>
                                    )}
                                />
                                <PrivateRoute
                                    exact
                                    path="/xef/machines/:machine"
                                    user={user}
                                    component={(props) => (
                                        <Home
                                            {...props}
                                            id={XEFID}
                                            back
                                            title={'manage_machines_menu'}
                                        >
                                            <Machine id={props.match.params.machine} />
                                        </Home>
                                    )}
                                />
                                <PrivateRoute
                                    exact
                                    path="/manage/user"
                                    user={user}
                                    component={(props) => (
                                        <Home
                                            {...props}
                                            id={MANAGEID}
                                            back
                                            title={'manage_user_menu'}
                                        >
                                            <Users />
                                        </Home>
                                    )}
                                />
                                <PrivateRoute
                                    exact
                                    path="/manage/user/:user"
                                    user={user}
                                    component={(props) => (
                                        <Home
                                            {...props}
                                            id={MANAGEID}
                                            back
                                            title={'manage_user_menu'}
                                        >
                                            <User id={props.match.params.user} />
                                        </Home>
                                    )}
                                />
                                <PrivateRoute
                                    exact
                                    path="/manage/new_user"
                                    user={user}
                                    component={(props) => (
                                        <Home
                                            {...props}
                                            id={MANAGEID}
                                            back
                                            title={'manage_new_user_menu'}
                                        >
                                            <User />
                                        </Home>
                                    )}
                                />
                                <PrivateRoute
                                    exact
                                    path="/manage/employees"
                                    user={user}
                                    component={(props) => (
                                        <Home
                                            {...props}
                                            id={MANAGEID}
                                            back
                                            title={'manage_employee_menu'}
                                        >
                                            <Employees />
                                        </Home>
                                    )}
                                />
                                <PrivateRoute
                                    exact
                                    path="/manage/employees/:employee"
                                    user={user}
                                    component={(props) => (
                                        <Home
                                            {...props}
                                            id={MANAGEID}
                                            back
                                            title={'manage_employee_menu'}
                                        >
                                            <Employee id={props.match.params.employee} />
                                        </Home>
                                    )}
                                />
                                <PrivateRoute
                                    exact
                                    path="/manage/new_employee"
                                    user={user}
                                    component={(props) => (
                                        <Home
                                            {...props}
                                            id={MANAGEID}
                                            back
                                            title={'manage_new_employee_menu'}
                                        >
                                            <Employee />
                                        </Home>
                                    )}
                                />

                                <PrivateRoute
                                    exact
                                    path="/manage/locals"
                                    user={user}
                                    component={(props) => (
                                        <Home {...props} id={MANAGEID} back title={'locals_menu'}>
                                            <LocalsInfo />
                                        </Home>
                                    )}
                                />
                                <PrivateRoute
                                    exact
                                    path="/manage/locals/:local"
                                    user={user}
                                    component={(props) => (
                                        <Home {...props} id={MANAGEID} back title={'locals_menu'}>
                                            <LocalInfo id={props.match.params.local} />
                                        </Home>
                                    )}
                                />
                                <PrivateRoute
                                    exact
                                    path="/manage/catalogs"
                                    user={user}
                                    component={(props) => (
                                        <Home
                                            {...props}
                                            id={MANAGEID}
                                            back
                                            title={'manage_catolog_menu'}
                                        >
                                            <Catalogs />
                                        </Home>
                                    )}
                                />
                                <PrivateRoute
                                    exact
                                    path="/manage/catalogs/:catalog"
                                    user={user}
                                    component={(props) => (
                                        <Home
                                            {...props}
                                            id={MANAGEID}
                                            back
                                            title={'manage_catolog_menu'}
                                        >
                                            <Catalog id={props.match.params.catalog} />
                                        </Home>
                                    )}
                                />
                                <PrivateRoute
                                    exact
                                    path="/manage/new_catalog"
                                    user={user}
                                    component={(props) => (
                                        <Home
                                            {...props}
                                            id={MANAGEID}
                                            back
                                            title={'manage_catolog_menu'}
                                        >
                                            <Catalog />
                                        </Home>
                                    )}
                                />
                                <PrivateRoute
                                    exact
                                    path="/manage/customers"
                                    user={user}
                                    component={(props) => (
                                        <Home
                                            {...props}
                                            id={MANAGEID}
                                            back
                                            title={'manage_customer_menu'}
                                        >
                                            <Customers />
                                        </Home>
                                    )}
                                />
                                <PrivateRoute
                                    exact
                                    path="/manage/customers/:customer"
                                    user={user}
                                    component={(props) => (
                                        <Home
                                            {...props}
                                            id={MANAGEID}
                                            back
                                            title={'manage_customer_menu'}
                                        >
                                            <Customer id={props.match.params.customer} />
                                        </Home>
                                    )}
                                />
                                <PrivateRoute
                                    exact
                                    path="/manage/new_customer"
                                    user={user}
                                    component={(props) => (
                                        <Home
                                            {...props}
                                            id={MANAGEID}
                                            back
                                            title={'manage_new_customer_menu'}
                                        >
                                            <Customer />
                                        </Home>
                                    )}
                                />
                                <PrivateRoute
                                    exact
                                    path="/manage/termometres"
                                    user={user}
                                    component={(props) => (
                                        <Home
                                            {...props}
                                            id={MANAGEID}
                                            back
                                            title={'manage_termometre_menu'}
                                        >
                                            <Termometres />
                                        </Home>
                                    )}
                                />
                                <PrivateRoute
                                    exact
                                    path="/manage/termometres/:termometre"
                                    user={user}
                                    component={(props) => (
                                        <Home
                                            {...props}
                                            id={MANAGEID}
                                            back
                                            title={'manage_termometre_menu'}
                                        >
                                            <Termometre id={props.match.params.termometre} />
                                        </Home>
                                    )}
                                />
                                <PrivateRoute
                                    exact
                                    path="/manage/new_termometre"
                                    user={user}
                                    component={(props) => (
                                        <Home
                                            {...props}
                                            id={MANAGEID}
                                            back
                                            title={'manage_new_termometre_menu'}
                                        >
                                            <Termometre />
                                        </Home>
                                    )}
                                />
                                <PrivateRoute
                                    exact
                                    path="/manage/displays"
                                    user={user}
                                    component={(props) => (
                                        <Home
                                            {...props}
                                            id={MANAGEID}
                                            back
                                            title={'manage_display_menu'}
                                        >
                                            <Displays />
                                        </Home>
                                    )}
                                />
                                <PrivateRoute
                                    exact
                                    path="/manage/displays/callback"
                                    user={user}
                                    component={(props) => (
                                        <Home
                                            {...props}
                                            id={MANAGEID}
                                            back
                                            title={'manage_display_menu'}
                                        >
                                            <DisplaysCallback />
                                        </Home>
                                    )}
                                />
                                <PrivateRoute
                                    exact
                                    path="/manage/displays/:display"
                                    user={user}
                                    component={(props) => (
                                        <Home
                                            {...props}
                                            id={MANAGEID}
                                            back
                                            title={'manage_display_menu'}
                                        >
                                            <Display id={props.match.params.display} />
                                        </Home>
                                    )}
                                />
                                <PrivateRoute
                                    exact
                                    path="/manage/new_display"
                                    user={user}
                                    component={(props) => (
                                        <Home
                                            {...props}
                                            id={MANAGEID}
                                            back
                                            title={'manage_new_display_menu'}
                                        >
                                            <Display />
                                        </Home>
                                    )}
                                />
                                <PrivateRoute
                                    exact
                                    path="/manage/providers"
                                    user={user}
                                    component={(props) => (
                                        <Home
                                            {...props}
                                            id={MANAGEID}
                                            back
                                            title={'manage_provider_menu'}
                                        >
                                            <Providers />
                                        </Home>
                                    )}
                                />
                                <PrivateRoute
                                    exact
                                    path="/manage/providers/:id"
                                    user={user}
                                    component={(props) => (
                                        <Home
                                            {...props}
                                            id={MANAGEID}
                                            back
                                            title={'manage_provider_menu'}
                                        >
                                            <Provider id={props.match.params.id} />
                                        </Home>
                                    )}
                                />
                                <PrivateRoute
                                    exact
                                    path="/manage/new_providers"
                                    user={user}
                                    component={(props) => (
                                        <Home
                                            {...props}
                                            id={MANAGEID}
                                            back
                                            title={'manage_provider_menu'}
                                        >
                                            <Provider />
                                        </Home>
                                    )}
                                />
                                <PrivateRoute
                                    exact
                                    path="/manage/templates"
                                    user={user}
                                    component={(props) => (
                                        <Home
                                            {...props}
                                            id={MANAGEID}
                                            back
                                            title={'manage_template_menu'}
                                        >
                                            <Templates />
                                        </Home>
                                    )}
                                />
                                <PrivateRoute
                                    exact
                                    path="/manage/templates/:id"
                                    user={user}
                                    component={(props) => (
                                        <Home
                                            {...props}
                                            id={MANAGEID}
                                            back
                                            title={'manage_template_menu'}
                                        >
                                            <Template id={props.match.params.id} />
                                        </Home>
                                    )}
                                />
                                <PrivateRoute
                                    exact
                                    path="/manage/new_template"
                                    user={user}
                                    component={(props) => (
                                        <Home
                                            {...props}
                                            id={MANAGEID}
                                            back
                                            title={'manage_template_menu'}
                                        >
                                            <Template />
                                        </Home>
                                    )}
                                />
                                <PrivateRoute
                                    exact
                                    path="/manage/references"
                                    user={user}
                                    component={(props) => (
                                        <Home
                                            {...props}
                                            id={MANAGEID}
                                            back
                                            title={'manage_reference_menu'}
                                        >
                                            <References />
                                        </Home>
                                    )}
                                />
                                <PrivateRoute
                                    exact
                                    path="/manage/references/:id"
                                    user={user}
                                    component={(props) => (
                                        <Home
                                            {...props}
                                            id={MANAGEID}
                                            back
                                            title={'manage_reference_menu'}
                                        >
                                            <Reference id={props.match.params.id} />
                                        </Home>
                                    )}
                                />
                                <PrivateRoute
                                    exact
                                    path="/manage/new_reference"
                                    user={user}
                                    component={(props) => (
                                        <Home
                                            {...props}
                                            id={MANAGEID}
                                            back
                                            title={'manage_reference_menu'}
                                        >
                                            <Reference />
                                        </Home>
                                    )}
                                />
                                <PrivateRoute
                                    exact
                                    path="/manage/roles"
                                    user={user}
                                    component={(props) => (
                                        <Home
                                            {...props}
                                            id={MANAGEID}
                                            back
                                            title={'roles_menu'}
                                            param={true}
                                        >
                                            <Roles />
                                        </Home>
                                    )}
                                />
                                <PrivateRoute
                                    exact
                                    path="/manage/roles/new"
                                    user={user}
                                    component={(props) => (
                                        <Home
                                            {...props}
                                            id={MANAGEID}
                                            back
                                            title={'roles_menu'}
                                            param={true}
                                        >
                                            <Roles add />
                                        </Home>
                                    )}
                                />
                                <PrivateRoute
                                    exact
                                    path="/manage/roles/clone/:id"
                                    user={user}
                                    component={(props) => (
                                        <Home
                                            {...props}
                                            id={MANAGEID}
                                            back
                                            title={'roles_menu'}
                                            param={true}
                                        >
                                            <Roles clone={props.match.params.id} />
                                        </Home>
                                    )}
                                />
                                <PrivateRoute
                                    exact
                                    path="/manage/roles/:id"
                                    user={user}
                                    component={(props) => (
                                        <Home
                                            {...props}
                                            id={MANAGEID}
                                            back
                                            title={'roles_menu'}
                                            param={true}
                                        >
                                            <Roles id={props.match.params.id} />
                                        </Home>
                                    )}
                                />
                                <PrivateRoute
                                    exact
                                    path="/manage/process"
                                    user={user}
                                    component={(props) => (
                                        <Home
                                            {...props}
                                            id={MANAGEID}
                                            back
                                            title={'manage_checks_menu'}
                                        >
                                            <ManageChecks code={1} />
                                        </Home>
                                    )}
                                />
                                <PrivateRoute
                                    exact
                                    path="/manage/process/:family"
                                    user={user}
                                    component={(props) => (
                                        <Home
                                            {...props}
                                            id={MANAGEID}
                                            param={props.match.params.family}
                                        >
                                            <ManageChecks
                                                code={2}
                                                family={props.match.params.family}
                                            />
                                        </Home>
                                    )}
                                />
                                <PrivateRoute
                                    exact
                                    path="/manage/process/:family/:process"
                                    user={user}
                                    component={(props) => (
                                        <Home
                                            {...props}
                                            id={MANAGEID}
                                            noprominent
                                            hide
                                            param={props.match.params.process}
                                        >
                                            <ManageCheckForms
                                                code={3}
                                                family={props.match.params.family}
                                                process={props.match.params.process}
                                            />
                                        </Home>
                                    )}
                                />
                                <PrivateRoute
                                    exact
                                    path="/communications"
                                    user={user}
                                    component={(props) => (
                                        <Home
                                            {...props}
                                            noprominent
                                            id={COMMUNICATIONS}
                                            title={'manage_communications'}
                                        >
                                            <Communications />
                                        </Home>
                                    )}
                                />
                                <PrivateRoute
                                    exact
                                    path="/communications/sent"
                                    user={user}
                                    component={(props) => (
                                        <Home
                                            {...props}
                                            noprominent
                                            id={COMMUNICATIONS}
                                            back
                                            title={'manage_communications'}
                                        >
                                            <Communications sent />
                                        </Home>
                                    )}
                                />
                                <PrivateRoute
                                    exact
                                    path="/communications/receive"
                                    user={user}
                                    component={(props) => (
                                        <Home
                                            {...props}
                                            noprominent
                                            id={COMMUNICATIONS}
                                            back
                                            title={'manage_communications'}
                                        >
                                            <Communications receive />
                                        </Home>
                                    )}
                                />
                                <PrivateRoute
                                    exact
                                    path="/communications/sent/new"
                                    user={user}
                                    component={(props) => (
                                        <Home
                                            {...props}
                                            noprominent
                                            id={COMMUNICATIONS}
                                            back
                                            title={'communication_new_message'}
                                        >
                                            <Communications sent isnew />
                                        </Home>
                                    )}
                                />
                                <PrivateRoute
                                    exact
                                    path="/communications/sent/:id"
                                    user={user}
                                    component={(props) => (
                                        <Home
                                            {...props}
                                            noprominent
                                            id={COMMUNICATIONS}
                                            back
                                            title={'manage_communications'}
                                        >
                                            <Communications sent param={props.match.params.id} />
                                        </Home>
                                    )}
                                />
                                <PrivateRoute
                                    exact
                                    path="/communications/receive/:id"
                                    user={user}
                                    component={(props) => (
                                        <Home
                                            {...props}
                                            noprominent
                                            id={COMMUNICATIONS}
                                            back
                                            title={'manage_communications'}
                                        >
                                            <Communications receive param={props.match.params.id} />
                                        </Home>
                                    )}
                                />
                                <Route path="*" component={NotFound} />
                            </Switch>
                        </LastLocationProvider>
                    </Router>
                </div>
                <div style={divStyle} className="message_rotate fullscreen center bg_ice_blue img">
                    <span className="barlow_medium center c_bluish margin_top_400">
                        Rotate your screen
                    </span>
                </div>
                <Sse {...this.props} />
                <Session {...this.props} />
            </div>
        );
    }
}

App.propTypes = {
    intl: intlShape.isRequired,
};

const mapStateToProps = (state) => {
    return {
        user: state.session.user,
        token: state.session.token,
        xeflocal: state.xeflocal,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(Object.assign({}, actionsSession, actionsAlert), dispatch);
};

export default withRoot(
    withStyles(styles, { withTheme: true })(
        connect(mapStateToProps, mapDispatchToProps)(injectIntl(App)),
    ),
);



// WEBPACK FOOTER //
// ./src/pages/app.js